import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-b from-dark-800 to-dark-900 border-t border-gold-500/20 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo and description */}
          <div>
            <img
              src="https://static.readdy.ai/image/55de03a58447b22c9804f3000d5f2dfc/7f3918d052d8bace5fe919afd77c8449.png"
              alt="Cuaderno de La Magdalena"
              className="h-16 w-auto mb-4"
            />
            <p className="font-sans text-warm-200 text-sm leading-relaxed">
              Una peregrinación interior de 40 días inspirada en la vida de María Magdalena.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-xl text-gold-400 mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/musica" className="font-sans text-warm-200 hover:text-gold-400 transition-colors cursor-pointer">
                  Canción "La Magdalena"
                </Link>
              </li>
              <li>
                <a href="#cuaderno" className="font-sans text-warm-200 hover:text-gold-400 transition-colors cursor-pointer">
                  Comprar Cuaderno
                </a>
              </li>
              <li>
                <a href="#curso" className="font-sans text-warm-200 hover:text-gold-400 transition-colors cursor-pointer">
                  Inscripción al Curso
                </a>
              </li>
              <li>
                <a href="#comunidad" className="font-sans text-warm-200 hover:text-gold-400 transition-colors cursor-pointer">
                  Comunidad WhatsApp
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-xl text-gold-400 mb-4">Contacto</h4>
            <div className="space-y-3">
              <a
                href="mailto:peregrinacioninterior@gmail.com"
                className="flex items-center gap-3 font-sans text-warm-200 hover:text-gold-400 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-xl"></i>
                peregrinacioninterior@gmail.com
              </a>
              <a
                href="https://chat.whatsapp.com/Dp55j3JPXRJ7rwbHSHjHIm"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-3 font-sans text-warm-200 hover:text-gold-400 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
              <a
                href="https://www.paypal.me/johannalvarezmusica?locale.x=en_US"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-3 font-sans text-warm-200 hover:text-gold-400 transition-colors cursor-pointer"
              >
                <i className="ri-paypal-line text-xl"></i>
                PayPal
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-gold-500/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-sans text-sm text-warm-200">
              © 2025 Cuaderno de La Magdalena. Todos los derechos reservados.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="font-sans text-sm text-warm-200 hover:text-gold-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}